import RecursoService from 'src/modules/recurso/recursoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'RECURSO_VIEW';

const recursoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: recursoViewActions.FIND_STARTED,
      });

      const record = await RecursoService.find(id);

      dispatch({
        type: recursoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: recursoViewActions.FIND_ERROR,
      });

      getHistory().push('/recurso');
    }
  },
};

export default recursoViewActions;
